import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus } from 'lucide-react';
interface AccordionProps {
  title: string;
  children: React.ReactNode;
}
export function Accordion({
  title,
  children
}: AccordionProps) {
  const [isOpen, setIsOpen] = useState(false);
  return <div className={`border rounded-2xl bg-white overflow-hidden transition-all ${isOpen ? 'border-clinical-deep/30' : 'border-clinical-line'}`} data-id="element-401">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-5 md:px-6 py-4 md:py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-402">
        <span className="font-semibold text-clinical-deep pr-4 text-sm md:text-base" data-id="element-403">
          {title}
        </span>
        <div className={`w-7 h-7 rounded-full flex items-center justify-center flex-shrink-0 transition-all border ${isOpen ? 'bg-clinical-deep border-clinical-deep text-white rotate-45' : 'border-clinical-line text-clinical-mid'}`} data-id="element-404">
          <Plus className="w-3.5 h-3.5" strokeWidth={2.5} data-id="element-405" />
        </div>
      </button>

      <AnimatePresence data-id="element-406">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} data-id="element-407">
            <div className="px-5 md:px-6 pb-5 pt-1 border-t border-clinical-line" data-id="element-408">
              {children}
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}